import { createSlice } from "@reduxjs/toolkit";

import { STATUS } from "../../../config/constants";

const initialState = {
  status: STATUS.NONE,
};

export const deletePlansTargetSlice = createSlice({
  name: "deletePlansTarget",
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  deletePlansTargetSlice.actions;

export const status = (state) => state.deletePlansTarget.status;

export const error = (state) => state.deletePlansTarget.error;

export default deletePlansTargetSlice.reducer;
